import React, { useState } from 'react';
import { View, Text, TextInput, Pressable } from 'react-native';
import { CampaignSignupClient, CampaignSetupEmailRequest } from '../../api/api.g';
import useApi from '../../hooks/api-hook';
import useCampaignTranslation from '../../hooks/campaign-translation-hook';
import { useAppDispatch, useAppSelector } from '../../hooks/store-hook';
import { authActions } from '../../models/helpers/platformImportHelper';

export default function CampaignSetupRequired() {
  const text = useCampaignTranslation();
  const api = useApi(CampaignSignupClient);
  const dispatch = useAppDispatch();
  const user = useAppSelector(s => s.auth.user);
  const [email, setEmail] = useState(user?.email ?? '');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const request = new CampaignSetupEmailRequest(); request.email = email.trim();
      await api.requestCampaignSetupEmail(request, undefined);
      setMessage(text('campaign-setup-email-sent', 'If this account needs setup, an email has been sent. Check your inbox.'));
    } catch { setMessage(text('campaign-signup-error', 'We could not complete this step. Try again or request an account setup email.')); }
    finally { setBusy(false); }
  };
  return <View style={{ flex: 1, justifyContent: 'center', padding: 24, backgroundColor: '#fff' }}>
    <Text style={{ color: '#035164', fontSize: 22, fontWeight: '700' }}>{text('campaign-setup-title', 'Welcome to Lanla')}</Text>
    <Text style={{ marginVertical: 16 }}>{text('campaign-setup-description', 'Confirm your email and choose a personal password before cashout or your next sign-in.')}</Text>
    <TextInput accessibilityLabel={text('campaign-email', 'Email')} value={email} onChangeText={setEmail} keyboardType="email-address" autoCapitalize="none" style={{ borderWidth: 1, padding: 12, borderRadius: 6 }} />
    <Pressable disabled={busy} onPress={() => void send()} style={{ marginVertical: 16, padding: 14, backgroundColor: '#035164', borderRadius: 8 }}><Text style={{ color: '#fff' }}>{text('campaign-send-setup', 'Send account setup email')}</Text></Pressable>
    <Text accessibilityLiveRegion="polite">{message}</Text>
    <Pressable onPress={() => dispatch(authActions.logout())} style={{ paddingVertical: 16 }}><Text>{text('campaign-normal-login', 'Go to sign in')}</Text></Pressable>
  </View>;
}
